import React from "react"
import { scaleTo, mapDesignToArea } from "../products/add/utils"

const Thumbnail = ({ size, mockup, design, mockupColor, style, ...rest }) => {
  const scale = size / mockup.width
  const printarea = scaleTo(mockup.printarea, scale)
  const mockupStyle = mockup.assets[mockupColor] || {}
  console.log("mockupColor", mockup.assets[mockupColor], mockupColor)
  return (
    <div
      {...rest}
      style={{
        position: "relative",
        overflow: "hidden",
        width: size,
        height: size,
        borderRadius: 4,
        border: "1px solid rgba(0,0,0,0.2)",
        ...style,
      }}>
      <img
        alt={mockupColor}
        src={mockupStyle.image}
        style={{
          width: "100%",
          backgroundColor: mockupStyle.background_color,
          backgroundImage: `url(${mockupStyle.background_image})`,
        }}
      />
      <div style={{ position: "absolute", ...printarea }}>
        {design && (
          <img
            src={design.url}
            alt=""
            style={{
              position: "absolute",
              ...mapDesignToArea(design, printarea),
            }}
          />
        )}
      </div>
    </div>
  )
}

export default Thumbnail



// WEBPACK FOOTER //
// ./src/lib/Thumbnail.js